var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isSociety) ? _c('div', {
    staticClass: "evaluation-tips"
  }, [_c('p', {
    staticClass: "point"
  }, [_vm._v("使用说明：")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "point",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("面试记录：")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', {
    staticClass: "point",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("参考说明：")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('p', {
    staticClass: "point em",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v(" 通过方式参考：")]), _vm._v(" "), _vm._m(3)]) : _c('div', {
    staticClass: "evaluation-tips"
  }, [_c('p', {
    staticClass: "point",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v(" 使用说明：")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('p', {
    staticClass: "point",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("面试记录：")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('p', {
    staticClass: "point",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("参考说明：")]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('p', {
    staticClass: "point em",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v(" 通过方式参考：")]), _vm._v(" "), _vm._m(7)])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('i'), _c('span', {
    staticClass: "em"
  }, [_vm._v("建议薪资")]), _vm._v("和"), _c('span', {
    staticClass: "em"
  }, [_vm._v("期望薪资")]), _vm._v("为必填项，建议薪资和期望薪资请面试官填写年薪")]), _vm._v(" "), _c('li', [_c('i'), _vm._v("评分标准作为参考，统一各组面试标准。面试者是否通过面试"), _c('span', {
    staticClass: "em"
  }, [_vm._v("由面试官根据实际情况决定")]), _vm._v("；")]), _vm._v(" "), _c('li', [_c('i'), _vm._v("以S\\A\\B\\C\\D数量作为面试者定级的参考。面试官给出建议薪资，最终"), _c('span', {
    staticClass: "em"
  }, [_vm._v("定级由外包管理委员会综合面试官提供的面试评估决定")]), _vm._v("。")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('i'), _vm._v("填写面试过程中评级的原因或者面试题目和答案；")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('i'), _vm._v("主属性采用SABCD的方式评价。")]), _vm._v(" "), _c('li', [_c('i'), _vm._v("表格中提供的题目以及解答为"), _c('span', {
    staticClass: "em"
  }, [_vm._v("参考题目以及参考解答，请勿直接使用")]), _vm._v("，关键点已经用对应的颜色标明"), _c('span', {
    staticClass: "orange"
  }, [_vm._v("S橙色")]), _vm._v("、"), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("A黄色")]), _vm._v("、"), _c('span', {
    staticClass: "blue"
  }, [_vm._v("B蓝色")]), _vm._v("、"), _c('span', {
    staticClass: "green"
  }, [_vm._v("C绿色")]), _vm._v("、"), _c('span', {
    staticClass: "black"
  }, [_vm._v("D黑色")])]), _vm._v(" "), _c('li', [_c('i'), _vm._v("评级中分值表示的是培养后外包所能到达的绩效水平（例如：预计王三同学在培养后该项能力可以达到S绩效同学的预期，给出S即可）")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("1. 所有必要属性评级为B,或者大于等于B；")]), _vm._v(" "), _c('li', [_vm._v("2. 游戏理解S，其他属性要求可以酌情降低，允许有一个C；")]), _vm._v(" "), _c('li', [_vm._v("3. 计算机基础和算法编程取最高分作为计算机综合分，计算机综合分为A或者以上，其他非计算机相关属性要求可以酌情降低，允许有一个C。")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('i'), _c('span', {
    staticClass: "em"
  }, [_vm._v("期望描述")]), _vm._v("为必填项；")]), _vm._v(" "), _c('li', [_c('i'), _vm._v("评分标准作为参考，统一各组面试标准。面试者是否通过面试"), _c('span', {
    staticClass: "em"
  }, [_vm._v("由面试官根据实际情况决定")]), _vm._v("；")]), _vm._v(" "), _c('li', [_c('i'), _vm._v("以S\\A\\B\\C\\D数量作为面试者定级的参考。面试官给出建议薪资，最终"), _c('span', {
    staticClass: "em"
  }, [_vm._v("定级由外包管理委员会综合面试官提供的面试评估决定")]), _vm._v("。")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('i'), _vm._v("填写面试过程中评级的原因或者面试题目和答案；")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('i'), _vm._v("主属性采用SABCD的方式评价；")]), _vm._v(" "), _c('li', [_c('i'), _vm._v("表格中提供的题目以及解答为"), _c('span', {
    staticClass: "em"
  }, [_vm._v("参考题目以及参考解答，请勿直接使用")]), _vm._v("，关键点已经用对应的颜色标明"), _c('span', {
    staticClass: "orange"
  }, [_vm._v("S橙色")]), _vm._v("、"), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("A黄色")]), _vm._v("、"), _c('span', {
    staticClass: "blue"
  }, [_vm._v("B蓝色")]), _vm._v("、"), _c('span', {
    staticClass: "green"
  }, [_vm._v("C绿色")]), _vm._v("、"), _c('span', {
    staticClass: "black"
  }, [_vm._v("D黑色")])]), _vm._v(" "), _c('li', [_c('i'), _vm._v("评级中分值表示的是培养后外包所能到达的绩效水平（例如：预计王三同学在培养后该项能力可以达到S绩效同学的预期，给出S即可）")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("1. 所有必要属性评级为B,或者大于等于B；")]), _vm._v(" "), _c('li', [_vm._v("2. 游戏理解S，其他属性要求可以酌情降低，允许有一个C；")]), _vm._v(" "), _c('li', [_vm._v("3. 计算机基础和算法编程取最高分作为计算机综合分，计算机综合分为A或者以上，其他非计算机相关属性要求可以酌情降低，允许有一个C。")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32046bb3"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/evaluation/society-form/society-form-tips.vue
// module id = null
// module chunks = 